import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { ConfirmModalComponent } from 'app/core/components/modals/confirm-modal/confirm-modal.component';
import { PopoverService } from 'app/core/services/popover.service';
import { deleteP2PPledge } from 'app/manage-p2p/features/p2p.actions';
import { PeerToPeerManageService } from 'app/manage-p2p/services/peer-to-peer-manage/peer-to-peer-manage.service';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { MdbPopoverDirective, MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { Subject } from 'rxjs';

let id = 1;

@Component({
  selector: 'app-p2p-donations-popover',
  standalone: true,
  imports: [CommonModule, MdbPopoverModule],
  templateUrl: './p2p-donations-popover.component.html',
  styleUrl: './p2p-donations-popover.component.scss'
})
export class P2pDonationsPopoverComponent implements OnInit, OnDestroy {

  @ViewChild('popover') popover: MdbPopoverDirective = null;

  @Input() data = null;
  
  public takeUntilSubject: Subject<any> = new Subject();

  private _id = id++;
  
  get id() {
    return `P2PPopoverEvent_${this._id}`;
  }

  public deleteBtnClasses = {
    'popover__action--disabled': true
  };
  
  modalRef: MdbModalRef<ConfirmModalComponent> | null = null;

  constructor(
    private popoverService: PopoverService,
    private peerToPeerManageService: PeerToPeerManageService,
    private store: Store,
    private modalService: MdbModalService,
  ) { }

  ngOnInit() {
    if(this.data.status === 0) {
      this.deleteBtnClasses['popover__action--disabled'] = false;
    }
  }

  onClickDelete() {
    const params = {
      pledgeId: this.data.id,
      p2pId: this.data.p2pId
    }

    this.modalRef =  this.modalService.open(ConfirmModalComponent, {
      ignoreBackdropClick: true,
      modalClass:'modal--paybee modal-sm',
      containerClass:'mdb-modal-backdrop-paybee',
      data: {
        title: 'Are you sure?',
        text: `Remove ${this.data.donorInfo.name}'s pledge of <b>${this.peerToPeerManageService.addCommasToNumber(this.data.amount)}</b> permanently.`,
        onClose: (status)=>{
          this.modalRef.close()
          if(status){
            this.store.dispatch({
              type: deleteP2PPledge.type,
              payload: params
            });
          }
        }
      }
    });
  }




  onPopoverShown(): void {
    this.popoverService.list[this.id] = this.popover;
  }

  onPopoverHidden(): void {
    delete this.popoverService.list[this.id];
  }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }
}
